export default __webpack_public_path__ + "static/media/function.75f04c78.svg";